'use client';

import MetricLineChart from '../MetricLineChart';
import MetricGauge from '../MetricGauge';
import MetricBarChart from '../MetricBarChart';

// Sample data: Time to patch trend by severity
const timeToPatchTrend = [
  { name: 'Week 1', Critical: 36, High: 168, Medium: 720 },
  { name: 'Week 2', Critical: 28, High: 144, Medium: 672 },
  { name: 'Week 3', Critical: 22, High: 120, Medium: 600 },
  { name: 'Week 4', Critical: 18, High: 96, Medium: 504 },
  { name: 'Week 5', Critical: 14, High: 84, Medium: 456 },
  { name: 'Week 6', Critical: 12, High: 72, Medium: 408 },
];

// Sample data: Distribution by severity
const patchDistributionData = [
  { name: 'Critical', '< 24h': 15, '24-48h': 8, '48-72h': 3, '> 72h': 2 },
  { name: 'High', '< 24h': 5, '24-48h': 12, '48-72h': 18, '> 72h': 8 },
  { name: 'Medium', '< 24h': 2, '24-48h': 5, '48-72h': 12, '> 72h': 28 },
];

// Sample data: Current status
const currentStatusData = [
  { name: 'Critical', open: 2, avgDays: 0.5 },
  { name: 'High', open: 8, avgDays: 3.2 },
  { name: 'Medium', open: 23, avgDays: 12.5 },
  { name: 'Low', open: 45, avgDays: 38.0 },
];

export function TimeToPatchTrend() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📉 Time to Patch Improvement (by Severity)</h3>
      <MetricLineChart
        data={timeToPatchTrend}
        lines={[
          { dataKey: 'Critical', name: 'Critical (hours)', color: '#EB5757' },
          { dataKey: 'High', name: 'High (hours)', color: '#F2C94C' },
          { dataKey: 'Medium', name: 'Medium (hours)', color: '#4A90E2' },
        ]}
        xAxisLabel="Week"
        yAxisLabel="Time to Patch (hours)"
        targetLine={24}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing significant improvement in patching critical vulnerabilities from 36 hours
        to 12 hours. The green line represents the 24-hour target for critical issues. High severity
        vulnerabilities now patched within 72 hours on average (down from 168 hours).
      </p>
    </div>
  );
}

export function TimeToPatchGauge() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">⚡ Critical Vulnerability Response Time</h3>
      <MetricGauge
        value={12}
        max={48}
        label="Time to Patch Critical Vulnerabilities"
        unit=" hrs"
        ranges={[
          { min: 0, max: 50, color: '#6FCF97', label: 'Excellent' },
          { min: 50, max: 75, color: '#4A90E2', label: 'Good' },
          { min: 75, max: 90, color: '#F2C94C', label: 'Needs Improvement' },
          { min: 90, max: 100, color: '#EB5757', label: 'Critical' },
        ]}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Current average of 12 hours for critical vulnerability patches is Excellent. This demonstrates
        strong security response capabilities and meets industry best practices (&lt; 24 hours).
      </p>
    </div>
  );
}

export function TimeToPatchDistribution() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📊 Patch Time Distribution</h3>
      <MetricBarChart
        data={currentStatusData}
        bars={[
          { dataKey: 'open', name: 'Open Vulnerabilities', color: '#E89841' },
        ]}
        xAxisLabel="Severity"
        yAxisLabel="Count"
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Current open vulnerabilities by severity. 2 critical issues (avg 0.5 days old) need immediate
        attention. 8 high-severity issues averaging 3.2 days should be prioritized. Medium and low
        severity vulnerabilities are within acceptable ranges but should be included in regular
        maintenance cycles.
      </p>
    </div>
  );
}
